import React from "react";

const SettlementID = ({ render, shipment }) => {

  let settlementId = shipment.settlementId

  if (render === "hide") {
    return null
  }
  if (render === "show" && shipment) return (
    <div>Remittance ID: {settlementId}</div>
  )
  else {
    return null;
  }
};

export default SettlementID;
